// extracted by mini-css-extract-plugin
export default {"workspaceBodyWrap":"workspace-body_workspaceBodyWrap__k1xxy","workspaceTableWrap":"workspace-body_workspaceTableWrap__vqtag"};